import ConfigClient, {getMarketConfigList} from './configClient';

const envUrl = 'https://fwuwa-stg.iot.dev-pmidce.com';
const rrpEnvUrl = 'https://fwuwa-stg.rrp-backend.com';
const deepEnvUrl = 'https://pmi-app-fwuwa-stg.rrp-backend.com';

const marketConfigsList = getMarketConfigList((marketName) => {
    return {
        urls: [`${envUrl}/${marketName}`, `${rrpEnvUrl}/${marketName}`, `${deepEnvUrl}/${marketName}`],
        configImport: () => import(`../marketConfigs/${marketName}/stg-web`),
    };
});

export default class ConfigClientStg extends ConfigClient {
    constructor() {
        super(marketConfigsList);
    }
}
